import React, { useEffect, useState } from 'react';
import DashboardHeader from '../components/DashboardHeader';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';
const DashboardPage = () => {
  const [stats, setStats] = useState({
    vehicles: 0,
    available: 0,
    maintenance: 0,
    avgKm: 0
  });

  useEffect(() => {
    // Example: fetch stats from backend, or compute from lists if you prefer
    fetchWithAuth(`${BACKEND_URL}/dashboard-stats`)
      .then(res => res.json())
      .then(data => setStats(data))
      .catch(() => {}); // fallback: keep zeros
  }, []);

  return (
    <div>
      <DashboardHeader stats={stats} />
      {/* You can add more dashboard widgets, charts, or summaries here */}
      <div className="mt-8">
        <h2 className="text-xl font-bold mb-4">Bienvenido al Panel de Control</h2>
        <p className="text-gray-700">
          Usa las pestañas superiores para gestionar vehículos, conductores, usuarios, asignaciones y viajes.
        </p>
      </div>
    </div>
  );
};

export default DashboardPage;